import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "@arco-design/web-react";
import { IconDelete } from "@arco-design/web-react/icon";

interface IDeletePostModalProps {
  postId: number;
  onDeletePost: (postId: number) => void;
}

const DeletePostModal = ({ postId, onDeletePost }: IDeletePostModalProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    onDeletePost(postId);
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <div>
      <Button
        style={{
          padding: 0,
          backgroundColor: "transparent",
        }}
        onClick={showModal}
      >
        <IconDelete />
      </Button>

      <Modal
        title={t('home_page.delete_post')}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelButtonProps={{ shape: "round" }}
        okButtonProps={{shape: "round"}}
        okText={t('common.delete_button')}
        cancelText={t('common.cancel_button')}
        className="feed-modal"
      >
        <p>{t('home_page.delete_post_confirmation_message')}</p>
      </Modal>
    </div>
  );
};

export default DeletePostModal;
